import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  variant?: 'plp' | 'watchlist';
}

/**
 * Product grid
 * Each child item should be a `li` element
 */
export const ProductGrid: FC<Props> = ({ children, variant = 'plp' }) => (
  <ul
    className={clsx('grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3', {
      ['lg:grid-cols-4']: variant === 'watchlist',
      ['xl:grid-cols-4']: variant === 'plp',
    })}
    data-testid="used-cars-result-grid"
  >
    {children}
  </ul>
);
